(() => {
  if (window.TreemmeProductState?.version === '2026.07.16.2') return;

  const palette = Object.freeze({
    CC: { name: 'Chrome', color: '#c8c8c8', metallic: 0.9, roughness: 0.24, opacity: 1, alphaMode: 'OPAQUE', map: 'textures/metal/SimpleMetal_MAP.jpg', normalMap: 'textures/metal/SimpleMetal_NORMAL.jpg' },
    NL: { name: 'Nickel poli', color: '#d1c6ba', metallic: 0.9, roughness: 0.28, opacity: 1, alphaMode: 'OPAQUE', map: 'textures/metal/SimpleMetal_MAP.jpg', normalMap: 'textures/metal/SimpleMetal_NORMAL.jpg' },
    NF: { name: 'Nickel brossé', color: '#bfb5aa', metallic: 1, roughness: 0.52, opacity: 1, alphaMode: 'OPAQUE', normalMap: 'textures/brushed/brushed_NORM.jpg' },
    DD: { name: 'Or 24', color: '#f7d380', metallic: 0.9, roughness: 0.28, opacity: 1, alphaMode: 'OPAQUE', map: 'textures/metal/SimpleMetal_MAP.jpg', normalMap: 'textures/metal/SimpleMetal_NORMAL.jpg' },
    DZ: { name: 'Or brossé', color: '#c5a06a', metallic: 0.8, roughness: 0.48, opacity: 1, alphaMode: 'OPAQUE', normalMap: 'textures/brushed/brushed_NORM.jpg' },
    SZ: { name: 'Or rose brossé', color: '#c79d8d', metallic: 0.8, roughness: 0.5, opacity: 1, alphaMode: 'OPAQUE', normalMap: 'textures/brushed/brushed_NORM.jpg' },
    HH: { name: 'Noir chromé poli', color: '#655f5c', metallic: 0.9, roughness: 0.24, opacity: 1, alphaMode: 'OPAQUE', map: 'textures/metal/SimpleMetal_MAP.jpg', normalMap: 'textures/metal/SimpleMetal_NORMAL.jpg' },
    CZ: { name: 'Noir chromé brossé', color: '#8c8982', metallic: 0.8, roughness: 0.48, opacity: 1, alphaMode: 'OPAQUE', normalMap: 'textures/brushed/brushed_NORM.jpg' },
    BB: { name: 'Blanc opaque', color: '#fafaf5', metallic: 0.08, roughness: 0.82, opacity: 1, alphaMode: 'OPAQUE', map: 'textures/metal/SimpleMetal_MAP.jpg', normalMap: 'textures/metal/SimpleMetal_NORMAL.jpg' },
    NN: { name: 'Noir opaque', color: '#2e2e2e', metallic: 0.08, roughness: 0.84, opacity: 1, alphaMode: 'OPAQUE', map: 'textures/metal/SimpleMetal_MAP.jpg', normalMap: 'textures/metal/SimpleMetal_NORMAL.jpg' },
    IS: { name: 'Inox brossé', color: '#cfccc1', metallic: 0.9, roughness: 0.5, opacity: 1, alphaMode: 'OPAQUE', normalMap: 'textures/brushed/brushed_NORM.jpg' },
    US: { name: 'Bronze brossé', color: '#d2b266', metallic: 1, roughness: 0.56, opacity: 1, alphaMode: 'OPAQUE', map: 'textures/brushed/us-diffuse.png', normalMap: 'textures/brushed/brushed_NORM.jpg' },
    UZ: { name: 'Laiton brossé', color: '#d8b56f', metallic: 0.8, roughness: 0.5, opacity: 1, alphaMode: 'OPAQUE', normalMap: 'textures/brushed/brushed_NORM.jpg' },
    KK: { name: 'Oxydé', color: '#d9c7b4', metallic: 1, roughness: 0.34, opacity: 1, alphaMode: 'OPAQUE', map: 'textures/KK/KK_color.png' },
    PVD01: { name: 'Gun Metal-PVD', color: '#655f5c', metallic: 0.8, roughness: 0.42, opacity: 1, alphaMode: 'OPAQUE', normalMap: 'textures/brushed/brushed_NORM.jpg' },
    PVD03: { name: 'Bronze-PVD', color: '#a87d65', metallic: 1, roughness: 0.44, opacity: 1, alphaMode: 'OPAQUE', normalMap: 'textures/brushed/brushed_NORM.jpg' },
    PVD04: { name: 'Yellow Gold-PVD', color: '#d1bc92', metallic: 0.9, roughness: 0.42, opacity: 1, alphaMode: 'OPAQUE', normalMap: 'textures/brushed/brushed_NORM.jpg' },
  });

  const excludedMaterial = /(glass|vetro|verre|ceram|porcelain|silicon|pbianco|pnero|pgrigio|led|display|number|sprite|water|acqua|hose|flex|fless|pvc|plastic|gomma|rubber|seal|internal|interno|tubo|tube|cable|cavo|wood|legno|marble|marmo|stone|pietra)/i;
  const finishMaterial = /(metal|chrome|cromo|inox|steel|acciaio|brass|ottone|finish|finitura|body|corpo|rubinet)/i;
  const finishMaterialCode = /^(?:CC|NL|NF|DD|DZ|SZ|HH|CZ|BB|NN|IS|US|UZ|KK|PVD01|PVD03|PVD04)(?:\.\d+)?$/i;
  const textureCaches = new WeakMap();
  const viewportLocks = new Map();

  function normalizeId(value) {
    return String(value || '').split('/').pop();
  }

  function parseMap(script) {
    try {
      const parsed = JSON.parse(script.textContent || '{}');
      parsed.variants = Array.isArray(parsed.variants) ? parsed.variants : [];
      return parsed;
    } catch (error) {
      script.dataset.parseError = error.message;
      return null;
    }
  }

  function maps() {
    return Array.from(document.querySelectorAll('script[data-treemme-variant-map]')).map(parseMap).filter(Boolean);
  }

  function mapForProduct(productId) {
    const normalized = normalizeId(productId);
    return maps().find((entry) => normalizeId(entry.productId) === normalized) || null;
  }

  function entryForVariant(productId, variantId) {
    const map = mapForProduct(productId);
    if (!map) return null;
    const normalized = normalizeId(variantId);
    return map.variants.find((entry) => normalizeId(entry.variantId) === normalized) || null;
  }

  function productInfoFor(productId) {
    const normalized = normalizeId(productId);
    return Array.from(document.querySelectorAll('product-info')).find((element) => normalizeId(element.dataset.productId) === normalized)
      || document.querySelector('product-info');
  }

  function selectNativeOption(choice) {
    const productId = choice.dataset.productId;
    const optionValue = choice.dataset.optionValue;
    const productInfo = productInfoFor(productId);
    const variantSelects = productInfo?.querySelector('variant-selects');
    if (!variantSelects || !optionValue) return false;
    const controls = Array.from(variantSelects.querySelectorAll('input[type="radio"], option'));
    const control = controls.find((candidate) => candidate.value === optionValue);
    if (!control) return false;
    if (control.tagName === 'OPTION') {
      const select = control.closest('select');
      if (!select) return false;
      select.value = optionValue;
      control.selected = true;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      control.checked = true;
      control.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  function lockViewport(choice) {
    const key = normalizeId(choice.dataset.productId);
    if (!key) return;
    const anchor = choice.closest('[data-treemme-3d-finish-viewer]') || choice;
    const lock = {
      x: window.scrollX,
      anchor,
      anchorTop: anchor.getBoundingClientRect().top,
      finishCode: choice.dataset.finishCode || '',
      choice,
    };
    viewportLocks.set(key, lock);
    window.setTimeout(() => {
      if (viewportLocks.get(key) === lock) restoreViewport(key);
    }, 2800);
  }

  function restoreViewport(productId) {
    const key = normalizeId(productId);
    const lock = viewportLocks.get(key);
    if (!lock) return;
    const restore = () => {
      if (viewportLocks.get(key) !== lock) return;
      const root = document.documentElement;
      const previousBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      const anchor = lock.anchor?.isConnected
        ? lock.anchor
        : Array.from(document.querySelectorAll('[data-treemme-3d-finish-viewer]')).find((element) => normalizeId(element.dataset.productId) === key);
      if (anchor) window.scrollTo(lock.x, window.scrollY + anchor.getBoundingClientRect().top - lock.anchorTop);
      const choice = lock.choice?.isConnected
        ? lock.choice
        : Array.from(document.querySelectorAll('[data-treemme-3d-finish-choice]')).find((element) => (
          normalizeId(element.dataset.productId) === key && element.dataset.finishCode === lock.finishCode
        ));
      choice?.focus?.({ preventScroll: true });
      root.style.scrollBehavior = previousBehavior;
    };
    [0, 80, 240, 500, 900, 1500, 2400].forEach((delay) => window.setTimeout(restore, delay));
    window.setTimeout(() => {
      if (viewportLocks.get(key) === lock) viewportLocks.delete(key);
    }, 2850);
  }

  function stabilizeViewerViewport(choice) {
    const productId = normalizeId(choice.dataset.productId);
    const anchor = choice.closest('[data-treemme-3d-finish-viewer]');
    if (!productId || !anchor) return;
    const anchorTop = anchor.getBoundingClientRect().top;
    const x = window.scrollX;
    const finishCode = choice.dataset.finishCode || '';
    const stopAt = performance.now() + 1800;
    let cancelled = false;
    const cancel = () => { cancelled = true; cleanup(); };
    const cleanup = () => {
      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((type) => window.removeEventListener(type, cancel, true));
    };
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((type) => window.addEventListener(type, cancel, { capture: true, once: true }));
    const maintain = () => {
      if (cancelled) return;
      const currentAnchor = anchor.isConnected
        ? anchor
        : Array.from(document.querySelectorAll('[data-treemme-3d-finish-viewer]')).find((element) => normalizeId(element.dataset.productId) === productId);
      if (!currentAnchor) return cleanup();
      const delta = currentAnchor.getBoundingClientRect().top - anchorTop;
      if (Math.abs(delta) > 0.5) {
        const root = document.documentElement;
        const previousBehavior = root.style.scrollBehavior;
        root.style.scrollBehavior = 'auto';
        window.scrollTo(x, window.scrollY + delta);
        root.style.scrollBehavior = previousBehavior;
      }
      if (performance.now() < stopAt) return window.requestAnimationFrame(maintain);
      cleanup();
      const currentChoice = Array.from(document.querySelectorAll('[data-treemme-3d-finish-choice]')).find((element) => (
        normalizeId(element.dataset.productId) === productId && element.dataset.finishCode === finishCode
      ));
      currentChoice?.focus?.({ preventScroll: true });
    };
    window.requestAnimationFrame(maintain);
  }

  function updateChoiceState(productId, entry) {
    const normalizedProduct = normalizeId(productId);
    document.querySelectorAll('[data-treemme-finish-choice]').forEach((choice) => {
      if (normalizeId(choice.dataset.productId) !== normalizedProduct) return;
      const selected = normalizeId(choice.dataset.variantId) === normalizeId(entry?.variantId);
      choice.classList.toggle('is-selected', selected);
      choice.classList.toggle('is-active', selected);
      choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    document.querySelectorAll('[data-treemme-product-state]').forEach((root) => {
      if (normalizeId(root.dataset.productId) !== normalizedProduct) return;
      root.querySelectorAll('[data-treemme-selected-finish]').forEach((element) => { element.textContent = entry?.optionValue || ''; });
      root.querySelectorAll('[data-treemme-selected-reference]').forEach((element) => { element.textContent = entry?.sku || ''; });
    });
  }

  function galleryFallback(productId, entry) {
    const map = mapForProduct(productId);
    if (!map) return;
    const productInfo = productInfoFor(productId);
    const mediaId = entry?.featuredMediaId || map.genericMediaId;
    const mediaPosition = entry?.featuredMediaPosition || map.genericMediaPosition;
    if (!mediaId || !mediaPosition) return;
    const gallery = productInfo?.querySelector('media-gallery') || document.querySelector('media-gallery');
    if (gallery && typeof gallery.setActiveMedia === 'function') {
      gallery.init?.();
      gallery.setActiveMedia({ featured_media: { id: mediaId, position: Number(mediaPosition) } });
    }
  }

  function checkForms(productId, variantId) {
    queueMicrotask(() => {
      const productInfo = productInfoFor(productId);
      if (!productInfo) return;
      const values = Array.from(productInfo.querySelectorAll('form[action*="/cart/add"] [name="id"]')).map((input) => normalizeId(input.value));
      const synced = values.length > 0 && values.every((value) => value === normalizeId(variantId));
      productInfo.dataset.treemmeFormsSynced = synced ? 'true' : 'false';
      productInfo.dataset.treemmeFormVariantIds = values.join(',');
    });
  }

  function hexToRgba(hex, opacity) {
    const value = hex.replace('#', '');
    return [0, 2, 4].map((offset) => Number.parseInt(value.slice(offset, offset + 2), 16) / 255).concat(opacity);
  }

  function materialMask(root) {
    try {
      const value = JSON.parse(root.dataset.materialMask || '[]');
      return Array.isArray(value) ? value.map((name) => String(name).toLowerCase()) : [];
    } catch {
      return [];
    }
  }

  function setRotationOnly(root, reason) {
    root.dataset.finishStatus = 'ROTATION_ONLY';
    root.dataset.materialStatus = reason || 'rotation_only';
    root.querySelectorAll('[data-treemme-3d-finish-controls]').forEach((element) => {
      element.hidden = true;
    });
    const intro = root.querySelector('[data-treemme-3d-intro]');
    if (intro) intro.textContent = 'Faites pivoter le modèle pour examiner le produit sous tous les angles.';
    const notice = root.querySelector('[data-treemme-3d-notice]');
    if (notice) notice.hidden = true;
  }

  async function chooseMaterials(root, viewer) {
    if (root.dataset.finishStatus === 'ROTATION_ONLY') return [];
    if (!viewer.model?.materials?.length) {
      setRotationOnly(root, 'no_material');
      return [];
    }
    const materials = viewer.model.materials;
    for (const material of materials) await material.ensureLoaded?.();
    const explicit = materialMask(root);
    if (explicit.length) return materials.filter((material) => explicit.includes(String(material.name || '').toLowerCase()));
    if (materials.length === 1) {
      const name = String(materials[0].name || '');
      if (!excludedMaterial.test(name)) return materials;
      setRotationOnly(root, 'excluded_single_material');
      return [];
    }
    const eligible = materials.filter((material) => {
      const name = String(material.name || '');
      return (finishMaterialCode.test(name.trim()) || finishMaterial.test(name)) && !excludedMaterial.test(name);
    });
    if (eligible.length) return eligible;
    setRotationOnly(root, 'ambiguous');
    return [];
  }

  function textureCache(viewer) {
    if (!textureCaches.has(viewer)) textureCaches.set(viewer, new Map());
    return textureCaches.get(viewer);
  }

  async function createTexture(viewer, path) {
    if (!path || typeof viewer.createTexture !== 'function') return null;
    const url = new URL(path, 'https://configuratore.rubinetterie3m.it/').href;
    const cache = textureCache(viewer);
    if (!cache.has(url)) cache.set(url, viewer.createTexture(url).catch(() => null));
    return cache.get(url);
  }

  async function setTexture(slot, viewer, path, requestIsCurrent) {
    if (!slot || typeof slot.setTexture !== 'function') return false;
    slot.setTexture(null);
    if (!path) return true;
    const texture = await createTexture(viewer, path);
    if (!requestIsCurrent() || !texture) return false;
    slot.setTexture(texture);
    return true;
  }

  async function applyMaterial(root, finishCode) {
    if (root.dataset.finishStatus === 'ROTATION_ONLY') return;
    const finish = palette[finishCode];
    const viewer = root.querySelector('model-viewer');
    if (!finish || !viewer?.model) return;
    const request = String(Number(root.dataset.materialRequest || 0) + 1);
    root.dataset.materialRequest = request;
    const requestIsCurrent = () => root.dataset.materialRequest === request;
    const materials = await chooseMaterials(root, viewer);
    if (!materials.length || !requestIsCurrent()) return;
    const rgba = hexToRgba(finish.color, finish.opacity);
    const readback = [];
    let texturesApplied = 0;
    for (const material of materials) {
      if (!requestIsCurrent()) return;
      const pbr = material.pbrMetallicRoughness;
      if (!pbr) continue;
      pbr.baseColorTexture?.setTexture?.(null);
      pbr.metallicRoughnessTexture?.setTexture?.(null);
      material.normalTexture?.setTexture?.(null);
      pbr.setBaseColorFactor(rgba);
      pbr.setMetallicFactor(finish.metallic);
      pbr.setRoughnessFactor(finish.roughness);
      material.setAlphaMode?.(finish.alphaMode);
      if (await setTexture(pbr.baseColorTexture, viewer, finish.map, requestIsCurrent)) texturesApplied += finish.map ? 1 : 0;
      if (await setTexture(material.normalTexture, viewer, finish.normalMap, requestIsCurrent)) texturesApplied += finish.normalMap ? 1 : 0;
      readback.push({
        name: material.name || '',
        color: Array.from(pbr.baseColorFactor || []),
        metallic: pbr.metallicFactor,
        roughness: pbr.roughnessFactor,
        alphaMode: material.getAlphaMode?.() || finish.alphaMode,
      });
    }
    if (!requestIsCurrent()) return;
    root.dataset.materialStatus = 'applied';
    root.dataset.materialApplied = finishCode;
    root.dataset.materialCount = String(materials.length);
    root.dataset.textureStatus = texturesApplied ? 'partial_or_complete' : 'factors_only';
    root.dataset.materialReadback = JSON.stringify(readback);
    root.querySelectorAll('[data-treemme-3d-selected]').forEach((element) => { element.textContent = finish.name; });
    root.dispatchEvent(new CustomEvent('treemme:3d-material-applied', { bubbles: true, detail: { finishCode, finish, readback, texturesApplied } }));
  }

  function loadViewer(root) {
    const viewer = root.querySelector('model-viewer');
    if (!viewer || viewer.getAttribute('src')) return;
    const source = viewer.dataset.src;
    if (source) viewer.setAttribute('src', source);
  }

  function initViewer(root) {
    if (root.dataset.viewerReady === 'true') return;
    root.dataset.viewerReady = 'true';
    root.querySelectorAll('[data-treemme-3d-finish-choice]').forEach((button) => {
      const finish = palette[button.dataset.finishCode];
      if (finish) button.style.setProperty('--finish-color', finish.color);
    });
    const viewer = root.querySelector('model-viewer');
    if (!viewer) return;
    viewer.addEventListener('load', () => {
      root.dataset.viewerStatus = 'ready';
      const productId = root.dataset.productId;
      const map = mapForProduct(productId);
      const activeChoice = root.querySelector('[data-treemme-3d-finish-choice][aria-pressed="true"]');
      const currentId = activeChoice?.dataset.variantId
        || new URL(window.location.href).searchParams.get('variant')
        || map?.selectedVariantId;
      const entry = entryForVariant(productId, currentId) || map?.variants?.[0];
      if (entry?.finishCode) applyMaterial(root, entry.finishCode);
    });
    viewer.addEventListener('error', () => {
      root.dataset.viewerStatus = 'error';
      root.querySelector('.treemme-3d-finish-viewer__media')?.setAttribute('hidden', '');
      const notice = root.querySelector('[data-treemme-3d-notice]');
      if (notice) {
        notice.hidden = false;
        notice.textContent = 'Le modèle 3D Treemme est temporairement indisponible. Les photos produit restent la référence.';
      }
    });
    const observer = new IntersectionObserver((entries, instance) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      loadViewer(root);
      instance.disconnect();
    }, { rootMargin: '500px 0px' });
    observer.observe(root);
    const activate = root.querySelector('[data-treemme-3d-activate]');
    activate?.addEventListener('click', () => {
      viewer.setAttribute('camera-controls', '');
      root.classList.add('is-3d-active');
      activate.hidden = true;
    });
    if (!window.matchMedia?.('(pointer: coarse)').matches) {
      viewer.setAttribute('camera-controls', '');
      root.classList.add('is-3d-active');
      if (activate) activate.hidden = true;
    }
  }

  function initAll() {
    document.querySelectorAll('[data-treemme-3d-finish-viewer]').forEach(initViewer);
    maps().forEach((map) => {
      const currentId = new URL(window.location.href).searchParams.get('variant') || map.selectedVariantId;
      const entry = entryForVariant(map.productId, currentId) || map.variants[0];
      if (!entry) return;
      updateChoiceState(map.productId, entry);
      galleryFallback(map.productId, entry);
      checkForms(map.productId, entry.variantId);
    });
  }

  document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-treemme-3d-finish-choice]');
    if (choice) stabilizeViewerViewport(choice);
  }, { capture: true });

  document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-treemme-finish-choice]');
    if (!choice) return;
    event.preventDefault();
    const preserveViewport = choice.matches('[data-treemme-3d-finish-choice]');
    if (preserveViewport) lockViewport(choice);
    const selected = selectNativeOption(choice);
    choice.dataset.nativeSelection = selected ? 'requested' : 'failed';
    if (preserveViewport && !selected) restoreViewport(choice.dataset.productId);
  });

  document.addEventListener('variant:changed', (event) => {
    const variant = event.detail?.variant;
    if (!variant?.id) return;
    const productInfo = event.target.closest?.('product-info') || document.querySelector('product-info');
    const productId = productInfo?.dataset.productId || maps().find((map) => map.variants.some((entry) => normalizeId(entry.variantId) === normalizeId(variant.id)))?.productId;
    if (!productId) return;
    const entry = entryForVariant(productId, variant.id);
    if (!entry) return;
    updateChoiceState(productId, entry);
    galleryFallback(productId, entry);
    checkForms(productId, entry.variantId);
    document.querySelectorAll('[data-treemme-3d-finish-viewer]').forEach((root) => {
      if (normalizeId(root.dataset.productId) === normalizeId(productId)) applyMaterial(root, entry.finishCode);
    });
    restoreViewport(productId);
  });

  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();

  window.TreemmeProductState = Object.freeze({ version: '2026.07.16.2', palette, applyMaterial, initAll });
})();
